<!-- PAGINATION symbol to load on screen - START -->
<div #loading class="spinner-class" *ngIf="loaderActivated">
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
</div>
<!-- PAGINATION symbol to load on screen - END -->

<div class="loggedin-feedback-container" *ngIf="!loaderActivated">
  <div class="love-to-hear-txt">
    {{ "help.guestfeedback" | cxTranslate }} 
  </div>
  <hr />
  <div class="feedback-detail-container" [formGroup]="guestFeedbackForm">
    <div class="row">
      <div class="col-lg-6">
        <div class="vs-text-field sub-content-field">
          <label><span class="star"></span>{{ "help.firstname" | cxTranslate }}  </label>
          <input
            type="text"
            formControlName="firstName"
            [ngClass]="
              isSubmitted &&
              guestFeedbackForm?.get('firstName')?.errors?.required
                ? 'error-select'
                : ''
            "
            (keypress)="keyPressAllowAlphabetsOnly($event)"
          />
          <span
            class="error"
            *ngIf="
              isSubmitted &&
              guestFeedbackForm?.get('firstName')?.errors?.required
            "
            >{{ "help.enterfirst" | cxTranslate }} </span
          >
        </div>
      </div>

      <div class="col-lg-6">
        <div class="vs-text-field sub-content-field">
          <label><span class="star"></span> {{ "help.lastname" | cxTranslate }} </label>
          <input
            type="text"
            formControlName="lastName"
            [ngClass]="
              isSubmitted &&
              guestFeedbackForm?.get('lastName')?.errors?.required
                ? 'error-select'
                : ''
            "
            (keypress)="keyPressAllowAlphabetsOnly($event)"
          />
          <span
            class="error"
            *ngIf="
              isSubmitted &&
              guestFeedbackForm?.get('lastName')?.errors?.required
            "
            >{{ "help.enterlast" | cxTranslate }} </span
          >
        </div>
      </div>
    </div>
    <div class="divider"></div>
    <div class="row">
      <div class="col-lg-6">
        <div class="vs-text-field sub-content-field">
          <label><span class="star"></span>{{ "help.phoneno" | cxTranslate }}  </label>
          <input
            type="text"
            formControlName="phoneNumber"
            (keypress)="acceptNumberOnly($event)"
            [ngClass]="
              isSubmitted &&
              (guestFeedbackForm?.get('phoneNumber')?.invalid ||
                guestFeedbackForm?.get('phoneNumber')?.errors?.required)
                ? 'error-select'
                : ''
            "
          />
          <span
            class="error"
            *ngIf="
              isSubmitted &&
              guestFeedbackForm?.get('phoneNumber')?.errors?.required
            "
            >{{ "help.enterphone" | cxTranslate }} </span
          >
          <span
            class="error"
            *ngIf="
              isSubmitted &&
              !guestFeedbackForm?.get('phoneNumber')?.errors?.required &&
              guestFeedbackForm?.get('phoneNumber')?.invalid
            "
            >{{ "help.validphone" | cxTranslate }} </span
          >
        </div>
      </div>
      <div class="col-lg-6">
        <div class="vs-text-field sub-content-field">
          <label><span class="star"></span> {{ "help.emailaddress" | cxTranslate }} </label>
          <input
            type="text"
            formControlName="emailAddress"
            [ngClass]="
              isSubmitted &&
              (guestFeedbackForm?.get('emailAddress')?.invalid ||
                guestFeedbackForm?.get('emailAddress')?.errors?.required)
                ? 'error-select'
                : ''
            "
          />
          <span
            class="error"
            *ngIf="
              isSubmitted &&
              guestFeedbackForm?.get('emailAddress')?.errors?.required
            "
            >{{ "help.enteremail" | cxTranslate }} </span
          >
          <span
            class="error"
            *ngIf="
              isSubmitted &&
              !guestFeedbackForm?.get('emailAddress')?.errors?.required &&
              guestFeedbackForm?.get('emailAddress')?.invalid
            "
            >{{ "help.validemail" | cxTranslate }} </span
          >
        </div>
      </div>
    </div>
    <div class="divider"></div>
    <div class="row">
      <div class="col-lg-12">
        <div class="form-sub-heading-txt">
          <span class="star"></span>{{ "help.reasonfeedback" | cxTranslate }}  
        </div>
        <ng-select
          class="subject-dropdown"
          formControlName="subjectChosen"
          [ngClass]="
            isSubmitted &&
            guestFeedbackForm?.get('subjectChosen')?.errors?.required
              ? 'error-select'
              : ''
          "
          [searchable]="false"
          [clearable]="false"
          placeholder='{{ "help.selectPlaceholder" | cxTranslate }}'
        >
          <ng-option
            class="subject-dropdown-option"
            *ngFor="let subject of subjectDropdownContents"
            [value]="subject.code"
          >
            {{ subject.name }}
          </ng-option>
        </ng-select>
        <span
          class="error"
          *ngIf="
            isSubmitted &&
            guestFeedbackForm?.get('subjectChosen')?.errors?.required
          "
          >{{ "help.reasonfeedbackenter" | cxTranslate }} </span
        >
      </div>
    </div>
    <div class="divider"></div>
    <div class="row">
      <div class="col-lg-12">
        <div class="form-sub-heading-txt">
          <span class="star"></span> {{ "help.message" | cxTranslate }} 
        </div>
        <div>
          <textarea
            class="subject-textarea-content"
            formControlName="subjectMessage"
            [maxlength]="maxSubjectMessageLength"
            (keyup)="checkLength($event)"
            [ngClass]="
              isSubmitted &&
              guestFeedbackForm?.get('subjectMessage')?.errors?.required
                ? 'error-select'
                : ''
            "
          ></textarea>
          <span
            class="error"
            *ngIf="
              isSubmitted &&
              guestFeedbackForm?.get('subjectMessage')?.errors?.required
            "
            >{{ "help.entermessage" | cxTranslate }} </span
          >
          <span class="characters-left"
            >{{ "help.characterleft" | cxTranslate }} 
            {{ this.maxSubjectMessageLength - this.content.length }}</span
          >
        </div>
      </div>
    </div>
    <div class="divider"></div>

    <div class="mt-question">
      <vs-feedback-attachments
        (updateFiles)="updateFile($event)"
        (removeFile)="removedFile($event)"
      ></vs-feedback-attachments>
    </div>
    <div class="divider"></div>
    <div class="btn-area">
      <button class="vs-primary-btn" (click)="submitFeedback()">SUBMIT</button>
    </div>
    <div class="divider"></div>
  </div>
</div>
